import React, { useState } from "react";
import AnimatedGridBackground from "./AnimatedGrid";
import "../../scss/posts.scss";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n/I18nProvider";

interface PostProps {
  id: number;
  title: string;
  content: string;
  imageUrl: string;
  link: string;
  data: string;
}

const Post: React.FC<PostProps> = ({ title, content, imageUrl, link, data }) => {
  const { t } = useI18n();
  const [imgSrc, setImgSrc] = useState<string>(imageUrl);

  return (
    <article className="Post">
      <img
        src={imgSrc}
        alt={title}
        onError={() => setImgSrc("/post_backup.png")}
      />

      <div className="content">
        <AnimatedGridBackground direction="up" duration={1.5}>
          <div>
            <span className="content__tag">{data}</span>
          </div>
          <h2 className="content__title">{title}</h2>
          <p className="content__text">{content}</p>
          <Link to={link} className="content__link">
             <span className="material-icons">{t("posts_read_more")}</span>
          </Link>
        </AnimatedGridBackground>
      </div>
    </article>
  );
};

export default Post;